import {
  CREATE_CENTRE_BOOKING_FAILURE,
  CREATE_CENTRE_BOOKING_REQUEST,
  CREATE_CENTRE_BOOKING_SUCCESS,
  GET_CENTRE_BOOKINGS_FAILURE,
  GET_CENTRE_BOOKINGS_REQUEST,
  GET_CENTRE_BOOKINGS_SUCCESS,
  RESET_CENTRE_BOOKING_STATE,
} from "./ActionType";

const initialState = {
  pagedCentreBookings: {},
  lastCreatedCentreBooking: null,
  loading: false,
  error: null,
};

export const centreBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CENTRE_BOOKING_REQUEST:
    case GET_CENTRE_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_CENTRE_BOOKING_SUCCESS:
      return {
        ...state,
        lastCreatedCentreBooking: action.payload,
        loading: false,
        error: null,
      };
    case GET_CENTRE_BOOKINGS_SUCCESS:
      return {
        ...state,
        pagedCentreBookings: action.payload,
        loading: false,
        error: null,
      };
    case CREATE_CENTRE_BOOKING_FAILURE:
    case GET_CENTRE_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_CENTRE_BOOKING_STATE:
      return {
        ...state,
        lastCreatedCentreBooking: null,
        error: null,
      };
    default:
      return state;
  }
};


